import 'blueimp-file-upload';

import type { ValidateFormApi } from './validate-form';

export type FileUploadFileConstraints = Pick<JQueryFileInputOptions,
'maxFileSize' |
'limitMultiFileUploads' |
'limitMultiFileUploadSize'
> & {
    minFileSize?: number;
};

export type FileUpload = {
    id: number;
    file: File;
    error: string | null;
    group: FileUploadGroup;
    metadata: Record<string, unknown>;
    paramName: string;
};

export type FileUploadGroup = {
    files: FileUpload[];
    processing: boolean;
    progress: number | undefined;
    contextIndex: number;
    error: boolean;
    metadata: Record<string, unknown>;
};

export type FileUploadStats = {
    processed?: number;
    files?: number;
    feerrors?: number;
    fedenied?: number;
    feduplicates?: number;
    fewarnings?: number;
    feimporting?: number;
    feimported?: number;
    fetotal?: number;
};

export type FileUploadResult = {
    log: string;
    stats: FileUploadStats;
};

export type FileUploadState = {
    files: FileUpload[];
    fileGroups: FileUploadGroup[];
};

export type FileUploadIndexObject = {
    contextIndex: number;
};

export type FileUploadInitEvent = {
    state: FileUploadState;
    formApi: ValidateFormApi;
    uploadApi: FileUploadApi;
};

export type FileUploadAddEvent = {
    group: FileUploadGroup;
};

export type FileUploadStartEvent = {
    state: FileUploadState;
    formApi: ValidateFormApi;
    preventDefault: () => void;
};

export type FileUploadBeforeSubmitEvent = {
    group: FileUploadGroup;
    formData: { name: string; value: string }[] | null;
    preventDefault: () => void;
};

export type FileUploadFinishEvent = {
    result: FileUploadResult;
};

export type FileUploadApi = {
    start: () => void;
    reset: () => void;
};
